import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  trafficStatusConfig: [],
  loadingTrafficStatusConfig: false,
};

const adminConfigSlice = createSlice({
  name: 'adminConfig',
  initialState,
  reducers: {
    getAdminConfig: () => {},
    saveAdminConfig: (state, { payload }) => {
      state.trafficStatusConfig = payload;
      state.loadingTrafficStatusConfig = false;
    },
    changeLoading: (state, { payload })=>{
      state.loadingTrafficStatusConfig = payload;
    }
  },
});

export const { getAdminConfig, saveAdminConfig, changeLoading } = adminConfigSlice.actions;

export default adminConfigSlice.reducer;
